import React from "react";
import { Box, Chip, Container, Paper, Stack, Typography } from "@mui/material";
import PublicMarketingShell from "../components/PublicMarketingShell";
import {
  publicCardSx,
  publicHeroChipSx,
  publicSubtitleSx,
  publicTitleSx,
} from "../constants/publicMarketingTheme";

const AboutPage = () => {
  return (
    <PublicMarketingShell>
      <Container maxWidth="lg">
        <Stack spacing={2} sx={{ mb: 3, animation: "fadeUp 500ms ease-out" }}>
          <Chip label="About JD Integrations" sx={publicHeroChipSx} />
          <Typography variant="h3" sx={publicTitleSx}>
            We help businesses run smarter operations.
          </Typography>
          <Typography sx={{ ...publicSubtitleSx, maxWidth: 760 }}>
            We build practical ERP experiences for fast-growing organizations
            that need visibility, control, and automation across core business
            modules.
          </Typography>
        </Stack>

        <Box
          sx={{
            animation: "fadeUp 700ms ease-out",
            display: "flex",
            flexWrap: "wrap",
            gap: 2.5,
          }}
        >
          <Box sx={{ flex: "1 1 420px", minWidth: 0 }}>
            <Paper sx={{ ...publicCardSx, p: 3, height: "100%" }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                Our Mission
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Help teams run finance and operations from one trusted source of
                truth, with secure role-based access and module-level
                subscriptions.
              </Typography>
            </Paper>
          </Box>
          <Box sx={{ flex: "1 1 420px", minWidth: 0 }}>
            <Paper sx={{ ...publicCardSx, p: 3, height: "100%" }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                Why Teams Choose Us
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                We focus on reliable workflows, practical integrations, and
                implementation speed, so teams can adopt confidently and scale.
              </Typography>
            </Paper>
          </Box>
        </Box>

        <Paper
          sx={{
            ...publicCardSx,
            mt: 3,
            p: 3,
            animation: "fadeUp 900ms ease-out",
            background:
              "linear-gradient(120deg, rgba(11, 18, 32, 0.95) 0%, rgba(15, 23, 42, 0.88) 100%)",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
            What makes us different
          </Typography>
          <Typography sx={{ opacity: 0.9 }}>
            We combine module flexibility, ERP-grade process design, and fast
            implementation support so your teams can focus on execution instead
            of disconnected tools.
          </Typography>
        </Paper>
      </Container>
    </PublicMarketingShell>
  );
};

export default AboutPage;
